import React from "react";
import { Box } from "@mui/material";
import { useImageBaseUrl } from "./nyHelpers";

const box = { backgroundColor: "#e0f7fa", border: "2px solid #59c3d8", borderRadius: 16, padding: "16px" };
const h3 = { fontFamily: '"Poppins", sans-serif', fontSize: 14, fontWeight: 700, textTransform: "uppercase", marginBottom: 8, color: "#007a8d" };
const p = { fontFamily: '"Poppins", sans-serif', fontSize: 13, color: "#444", margin: 0 };

const Template99 = ({ headerBackgroundColor, headerTextColor, fontFamily, page, updatePage }) => {
	const BASE = useImageBaseUrl();
	return (
	<Box sx={{ display: "flex", flexDirection: "column", height: "100%", backgroundColor: "#f7f7f7", fontFamily: fontFamily || '"Poppins", sans-serif', "& *": { fontFamily: (fontFamily || '"Poppins", sans-serif') + "!important" } }}>
		<div data-block-id="header" style={{ backgroundColor: headerBackgroundColor || "#59c3d8", color: headerTextColor || "#fff", textAlign: "center", padding: "15px 0", fontSize: "14px", fontWeight: 700, flexShrink: 0, position: "sticky", top: 0, zIndex: 99999 }}>
			Invítanos a un Kofi 😊
		</div>
		<div data-block-id="text-1" style={{ padding: 20 }}>
			<div style={{ ...box, padding: 20 }}>
				<h2 style={{ ...h3, marginTop: 0, paddingTop: 0, textAlign: "center" }}>¿Te ha gustado la guía?</h2>
				<p style={p}>Si te ha servido y te apetece apoyarnos, puedes invitarnos a un café:</p>
				<img src={`${BASE}cafe-ny.png`} alt="cafe" style={{ display: "block", margin: "auto", marginTop: 40, marginBottom: 20, maxWidth: "80%", width: 130 }} />
				<a
					href="https://ko-fi.com/viajesmolones"
					style={{
						backgroundColor: "#59c3d8",
						color: "#ffffff",
						border: "none",
						borderRadius: "8px",
						padding: "12px 12px",
						fontWeight: 700,
						cursor: "pointer",
						fontFamily: '"Poppins", sans-serif',
						marginTop: 20,
						display: "block",
						textAlign: "center",
						textDecoration: "none",
					}}
					target="_blank"
					rel="noreferrer"
				>
					Invitar a un Kofi <img style={{ width: 20, verticalAlign: "middle", marginLeft: 5 }} src={`${BASE}kofi.png`} alt="kofi" />
				</a>
				<p style={{ ...p, textAlign: "center", marginTop: 20 }}>¡Gracias por tu apoyo!</p>
			</div>
		</div>
	</Box>
	);
};

export default Template99;
